// Scanner audit B5: one row state across every scanner table, decided by the server (futures_row_state.py,
// options_service row_state.py) and only worded here. TRADABLE is a discovery-time verdict: the ticket and the
// engine re-check everything before any order, so a TRADABLE row can still be refused.
const STATE = {
  TRADABLE: ["TRADABLE", "bg-[#00C805]/15 text-[#00C805]", "Passed the scanner's checks on executable prices quoted within seconds. The order path re-checks everything."],
  INDICATIVE: ["INDICATIVE", "bg-[#B45309]/15 text-[#B45309]", "Priced on last traded prices or with leg warnings - not where an order executes now."],
  STALE: ["STALE", "bg-[#FF3B30]/15 text-[#FF6b62]", "A leg's quote is too old to enter on right now."],
  BLOCKED: ["BLOCKED", "bg-[#FF3B30]/25 text-[#FF3B30]", "The trade path would refuse this row as it stands."],
  DISCOVERED: ["DISCOVERED", "bg-[var(--term-s3)] text-[var(--term-muted)]", "The formula qualifies, but something is not known yet."],
};

/** The row's state as a badge; the reasons are in the tooltip. Nothing when the server sent no state. */
export default function RowStateBadge({ state, testId }) {
  const s = state && STATE[state.state];
  if (!s) return null;
  const reasons = (state.reasons || []).join(", ");
  return (
    <span className={`text-[9px] font-bold px-1 rounded-sm whitespace-nowrap ${s[1]}`} data-testid={testId}
      title={reasons ? `${s[2]}\n${reasons}` : s[2]}>{s[0]}</span>
  );
}
